import React from 'react'
import ContentTemplate from '../../components/common/ContentTemplate'
import SubContentTemplate from '../../components/common/SubContentTemplate'
import PageHeaderContainer from '../../containers/common/PageHeaderContainer'
import PageTitleTemplate from '../../components/common/PageTitleTemplate'
import BreadcrumbContainer from '../../containers/common/BreadcrumbContainer'
import PageTemplate from '../../components/common/PageTemplate'
import { WIZPARK_ULTRAFINEDUST, WIZPARK_FINEDUST_TAB } from '../../constants/page'
import FineDust from '../../components/wizpark/dust/FineDust'

const WizparkUltrafineDustPage = ({ match }) => {
  return (
    <PageTemplate className="park">
      <PageHeaderContainer title="미세먼지 현황" subtitle="" image={require('../../assets/img/park/sub_tit_park.png')} forwardTabs={WIZPARK_FINEDUST_TAB} currentPath={match.path} />
      <ContentTemplate>
        <PageTitleTemplate>
          <BreadcrumbContainer page={WIZPARK_ULTRAFINEDUST} />
        </PageTitleTemplate>
        <SubContentTemplate className="park parking reservation">
          <FineDust pm='pm25G' />
        </SubContentTemplate>
      </ContentTemplate>
    </PageTemplate>
  )
}

export default WizparkUltrafineDustPage
